import React from "react";
import "./WebDevelopment.css";
import ScrollToTop from "../components/ScrollToTop";
import { useNavigate } from "react-router-dom";

import dynamic from "../assets/dynamic.jpeg";
import ecommerce from "../assets/ecommerce site.jpeg";
import webHero from "../assets/web.jpeg";
import web4 from "../assets/responsive.png";

const WebDevelopment = () => {
  const navigate = useNavigate();

  const expertiseCards = [
    {
      img: web4,
      title: "Static Website",
      theme: "purple",
      points: [
        "Fast loading and lightweight pages",
        "SEO friendly structure for better visibility",
        "Mobile first responsive design",
        "Clean UI for brand presentation",
        "Perfect for portfolios & business websites",
      ],
    },
    {
      img: dynamic,
      title: "Dynamic Website",
      theme: "blue",
      points: [
        "Admin panel / CMS based content updates",
        "Database integration for scalable growth",
        "Custom features & interactive pages",
        "User login, forms, dashboards & more",
        "API integrations for advanced functionality",
      ],
    },
    {
      img: ecommerce,
      title: "E-commerce Website",
      theme: "navy",
      points: [
        "Product listing & category management",
        "Cart, checkout & order tracking system",
        "Payment gateway integration",
        "Inventory & customer management",
        "Built for conversions & revenue growth",
      ],
    },
  ];

  const handleLearnMore = () => {
    navigate("/contact");
  };

  return (
    <>
      <ScrollToTop />

      <section className="service-page web-development-page">
        {/* ================= HERO ================= */}
        <div className="web-hero">
          <div className="web-hero-inner">
            <div className="web-hero-content">
              <h1 className="web-hero-title">
                <span className="web-highlight">Web Development</span> That Looks
                Great & Performs Fast
              </h1>

              <p className="web-hero-description">
                We build clean, modern, and responsive websites that are optimized
                for speed, SEO, and conversion. From landing pages to full scale
                web applications, our solutions are crafted to deliver smooth user
                experiences, strong security, and scalable performance across all devices.
              </p>

              <button className="web-hero-btn" onClick={handleLearnMore}>
                Get In Touch
              </button>
            </div>

            <div className="web-hero-image">
              <img src={webHero} alt="Web Development Hero" />
            </div>
          </div>
        </div>

        {/* ================= EXPERTISE ================= */}
        <div className="service-container" id="web-expertise">
          <header className="web-section-header">
            <h2 className="web-section-title">We Provide Expertise In</h2>
            <p className="web-section-subtitle">
              From simple websites to scalable platforms, we build solutions that match
              your business goals and deliver real performance.
            </p>
          </header>

          <div className="web-expertise-grid">
            {expertiseCards.map((card, idx) => (
              <article className={`exp-card exp-${card.theme}`} key={idx}>
                <div className="exp-media">
                  <img src={card.img} alt={card.title} loading="lazy" />
                </div>

                <div className="exp-body">
                  <h3 className="exp-title">{card.title}</h3>

                  <ul className="exp-points">
                    {card.points.map((p, i) => (
                      <li key={i}>
                        <span className="exp-icon">↗</span>
                        <span className="exp-text">{p}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </article>
            ))}
          </div>
        </div>

        {/* ================= WHY CHOOSE US ================= */}
        <div className="service-container" id="why-choose-us">
          <div className="why-choose-box">
            <h2 className="why-title">Why Choose THE WE DEV?</h2>

            <ul className="why-points">
              <li>
                <span className="why-icon">⚡</span>
                <span>
                  <strong>Performance first development</strong> : Every website is
                  optimized for speed, stability, and smooth user experience from day one.
                </span>
              </li>
              <li>
                <span className="why-icon">🔍</span>
                <span>
                  <strong>SEO ready structure</strong> : We build websites with clean
                  code, proper hierarchy, and technical SEO best practices built in.
                </span>
              </li>
              <li>
                <span className="why-icon">🎯</span>
                <span>
                  <strong>Conversion focused design</strong> : Layouts are planned to
                  guide users, improve engagement, and turn visits into real leads.
                </span>
              </li>
              <li>
                <span className="why-icon">🚀</span>
                <span>
                  <strong>Scalable & future proof</strong> : Our solutions grow with your
                  business, allowing easy upgrades, integrations, and expansion.
                </span>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </>
  );
};

export default WebDevelopment;
